<template>
    <div class="order-edit-modal">
        <header class="order-summary-modal__header">
            <h3 class="order-summary-modal__heading">
                Abo anpassen
            </h3>
        </header>
        <div class="order-edit-modal__deliveries business">
            <div class="order-edit-modal__deliveries__col-container">
                <div v-if="!isDisabledMonday" class="order-edit-modal__deliveries__col order-edit-modal__deliveries__col-1 business">
                    <delivery-day
                        title="Montagslieferung"
                        day="monday"
                        :orderable-intervals="orderableIntervals"
                        :orderable-baskets="orderableBaskets"
                        :intervals="intervals"
                        :baskets="baskets"
                        :set-delivery-interval="setDeliveryInterval"
                        :edit-basket="editBasket"
                    />
                </div>
                <div
                    v-if="!isDisabledWednesday"
                    :class="{'order-edit-modal__deliveries__col-container--border-visible' : !isDisabledMonday }"
                    class="order-edit-modal__deliveries__col order-edit-modal__deliveries__col-2 business"
                >
                    <delivery-day
                        title="Mittwochslieferung"
                        day="wednesday"
                        :orderable-intervals="orderableIntervals"
                        :orderable-baskets="orderableBaskets"
                        :intervals="intervals"
                        :baskets="baskets"
                        :set-delivery-interval="setDeliveryInterval"
                        :edit-basket="editBasket"
                    />
                </div>
            </div>
        </div>
        <div class="order-edit-modal__footer btn-container">
            <button
                class="order-edit-modal__link-submit"
                name="submit"
                @click="save"
            >
                Speichern
            </button>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'; // eslint-disable-line
import _ from 'lodash';
import { mapState, mapGetters } from 'vuex';

import DeliveryDay from './DeliveryDay.vue';
import BasketInput from './BasketInput.vue';

export default {
    components: {
        BasketInput,
        DeliveryDay,
    },
    data() {
        // only way to clone a state object...
        const { state } = this.$store;
        const baskets = _.cloneDeep(state.baskets);
        const intervals = _.cloneDeep(state.intervals);
        const subscriptionType = state.subscriptionType;
        return {
            baskets,
            intervals,
            subscriptionTypeId: subscriptionType,
        };
    },
    computed: {
        ...mapState({
            editModeVisible: state => state.editModeVisible,
            subscriptionTypes: state => state.orderable.product_groups,
            orderableIntervals: state => state.orderable.intervals,
        }),
        ...mapGetters([
            'orderableBaskets',
            'subscriptionType',
        ]),
        isDisabledMonday() {
            return !this.subscriptionType.products[0].delivery_days.some(p => p === 1);
        },
        isDisabledWednesday() {
            return !this.subscriptionType.products[0].delivery_days.some(p => p === 3);
        },
    },
    methods: {
        basketsCount(day, id) {
            return this.baskets[day].filter(b => b.id === id).length;
        },
        toggleEditModalVisible() {
            this.$store.commit('toggleEditModalVisible');
        },
        save() {
            const { baskets, intervals, subscriptionTypeId } = this;
            // send baskets to store
            this.$store.dispatch('saveEdit', {
                baskets,
                intervals,
                subscriptionType: subscriptionTypeId,
            });

            // GTM VirtualPageview
            const { dataLayer } = window;
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    event: 'VirtualPageview',
                    virtualPageURL: '/de/bio-furs-buro/abo-anpassen',
                    virtualPageTitle: 'Abo Bestellen Büro - Abo anpassen',
                });
            }
        },
        updateActiveSubscriptionType(id) {
            this.subscriptionTypeId = id;
        },
        setDeliveryInterval(id, day) {
            this.intervals[day] = id;
        },
        editBasket({ day, basket, value }) {
            const { id } = basket;
            // add
            if (value > this.baskets[day].filter(b => b.id === id).length) {
                this.baskets[day] = [...this.baskets[day], {
                    ...basket,
                }];
            } else {
                // remove
                const basketIndex = this.baskets[day].findIndex(b => b.id === id);
                this.baskets[day].splice(basketIndex, 1);
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// Edit.vue?4067d86e